import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer',
    attributes: { id: 'e1a7647e-1f28-47ac-a83e-4aea80bff845' },
  },
  // ---- CADASTROS ----
  {
    name: 'Cadastros Base',
    url: '.',
    title: true,
    attributes: { permission: { namespace: 'people' } },
  },
  {
    name: 'Pessoas',
    url: '/cadastro/person',
    icon: 'fas fa-user-friends',
    attributes: {
      id: '39689847-e155-41e5-88e1-c3e9874f04bd',
      permission: { namespace: 'people', action: 'person_list' },
    },
  },
  // {
  //   name: 'Fiéis',
  //   url: '/cadastro/member',
  //   icon: 'fa fa-users',
  //   attributes: { permission: { namespace: 'associated', action: 'member_list' } },
  // },
  {
    name: 'Dizimistas',
    url: '/cadastro/dizimista',
    icon: 'fas fa-hand-holding-heart',
    attributes: {
      id: '427d0c65-cabf-49a3-aa6a-cfce6bcc1999',
      permission: { namespace: 'dizimo', action: 'dizimista_list' },
    },
  },
  {
    name: 'Diversos',
    icon: 'fas fa-bars',
    url: '.',
    children: [
      {
        name: 'Categorias',
        url: '/cadastro/categorias',
        icon: 'far fa-circle',
        attributes: {
          id: '2b044913-65bb-4c7f-83cb-f6899e4f3378',
          permission: { namespace: 'people', action: 'category_list' },
        },
      },
      {
        name: 'Comunidade',
        url: '/cadastro/community',
        icon: 'far fa-circle',
        attributes: {
          id: '1317a060-fdfe-47db-bd95-c271ebef448d',
          permission: { namespace: 'people', action: 'community_list' },
        },
      },
      {
        name: 'Parentesco',
        url: '/cadastro/kinship',
        icon: 'far fa-circle',
        attributes: {
          id: '1af0c41d-e128-4687-bd83-e71f0dcd1f03',
          permission: { namespace: 'people', action: 'kinship_list' },
        },
      },
    ]
  },
  // ---- Dízimo ----
  {
    name: 'Dízimo',
    url: '/dizimo/dashboard',
    title: true,
    attributes: {
      id: 'b77e1e58-b37b-4afa-8134-f5fb6ce27b16',
      permission: { namespace: 'dizimo' },
    },
  },
  {
    name: 'Apuração',
    url: '/dizimo/apuracao',
    icon: 'far fa-money-bill-alt',
    attributes: {
      id: 'b9b2d4e4-5bb1-4cb4-bd9c-7e7e1d13ecc3',
      permission: { namespace: 'dizimo', action: 'apuracao_list' },
    },
  },
  // ---- AGENDA ----
  // {
  //   name: 'AGENDA',
  //   url: '.',
  //   title: true,
  //   attributes: { permission: { namespace: 'schedule' } },
  // },
  // {
  //   name: 'Agendas',
  //   icon: 'far fa-calendar',
  //   url: '/schedule/schedule',
  //   attributes: { permission: { namespace: 'schedule', action: 'schedule_list' } },
  // },
  // ---- Financeiro ----
  {
    name: 'Financeiro',
    url: '.',
    title: true,
    attributes: { permission: { namespace: 'finance' } },
  },
  {
    name: 'Banco / Caixa',
    url: '/finance/lancamento',
    icon: 'fas fa-wallet',
    attributes: {
      id: 'a8c83dec-2ba2-4098-bf77-9cb58ec6964f',
      permission: { namespace: 'finance', action: 'lancamento_list' }
    },
  },
  {
    name: 'Contas a Pagar',
    url: '/finance/conta-pagar',
    icon: 'fas fa-money-bill-wave',
    attributes: {
      id: '35be888b-a05f-49b4-a166-8e0b9db63121',
      permission: { namespace: 'finance', action: 'conta_pagar_list' },
    },
  },
  {
    name: 'Cheques',
    icon: 'fas fa-money-check-alt',
    url: '/finance/cheque/',
    attributes: {
      id: '2fd05ad8-1ffa-4d45-806c-ddd33705e2a4',
      permission: { namespace: 'finance', action: 'cheque' },
    },
    children: [
      {
        name: 'Emitidos',
        url: '/finance/cheque/emitido/',
        icon: 'fas fa-money-check-alt',
        attributes: {
          id: 'ce3de06f-355b-4e91-85ac-61712a97dc49',
          permission: { namespace: 'finance', action: 'cheque_emitido_list' },
        },
      },
      {
        name: 'Recebidos',
        url: '/finance/cheque/recebido/',
        icon: 'fas fa-money-check-alt',
        attributes: {
          id: '35497166-9761-4828-9096-08f1c127a1b0',
          permission: { namespace: 'finance', action: 'cheque_recebido_list' },
        },
      },
    ]
  },
  {
    name: 'Diversos',
    icon: 'fas fa-bars',
    url: '.',
    children: [
      {
        name: 'Banco / Caixa',
        icon: 'fas fa-wallet',
        url: '.',
        children: [
          {
            name: 'Conta',
            url: '/finance/conta',
            attributes: {
              id: 'c694b2e2-5c4b-4b28-b0ac-872a9a4bff4a',
              permission: { namespace: 'finance', action: 'conta_list' },
            },
          },
          {
            name: 'Tipo Conta',
            url: '/finance/tipo-conta',
            attributes: {
              id: '76cfb808-5de1-4efe-aa7e-408fd46ed1c7',
              permission: { namespace: 'finance', action: 'conta_tipo_list' },
            },
          },
        ]
      },
      {
        name: 'Categorias',
        icon: 'fas fa-layer-group',
        url: '.',
        children: [
          {
            name: 'Entradas',
            url: '/finance/categoria-entrada',
            icon: 'fas fa-arrow-down',
            attributes: {
              id: '2175129a-f0b8-4064-bb03-8d3778338827',
              permission: { namespace: 'finance', action: 'categoria_entrada_list' },
            },
          },
          {
            name: 'Saídas',
            url: '/finance/categoria-saida',
            icon: 'fas fa-arrow-up',
            attributes: {
              id: '6cd8e9fa-e136-42bf-8afb-296de9ac680f',
              permission: { namespace: 'finance', action: 'categoria_saida_list' },
            },
          },
        ]
      },
      {
        name: 'Formas',
        icon: 'far fa-handshake',
        url: '.',
        children: [
          {
            name: 'Pagamento',
            url: '/finance/forma-pagamento',
            icon: 'fas fa-arrow-up',
            attributes: {
              id: '3f7e716d-93dc-4f24-bdbd-1c0f115770ec',
              permission: { namespace: 'finance', action: 'forma_pagamento_list' },
            },
          },
          {
            name: 'Recebimento',
            url: '/finance/forma-recebimento',
            icon: 'fas fa-arrow-down',
            attributes: {
              id: '84372f76-1fab-4ecf-80c4-683d7b04539d',
              permission: { namespace: 'finance', action: 'forma_recebimento_list' },
            },
          },
        ]
      },
    ]
  },
  // ---- Relatórios ----
  {
    name: 'Relatórios',
    url: '.',
    title: true,
  },
  {
    name: 'Financeiro',
    url: '/finance/report',
    icon: 'fas fa-print',
    attributes: {
      id: 'c4cbda16-d5cd-4bc6-9a27-757379c54d47',
      permission: { namespace: 'finance' },
    },
  },
  {
    name: 'Pessoas',
    url: '/cadastro/report',
    icon: 'fas fa-print',
    attributes: {
      id: '398cc0f5-2986-4509-824d-5877b54f1fab',
      permission: { namespace: 'people' },
    },
  },
  // ---- Operações ----
  // Operações sobre os cadastros: alteram dados em massa, ao contrário
  // dos catálogos de "Configurações". O menu filtra só por permissão — a
  // feature flag por organização (D7) não é conhecida aqui, e numa
  // organização sem ela é a própria tela que informa a indisponibilidade.
  {
    name: 'Operações',
    icon: 'fas fa-random',
    url: '.',
    attributes: {
      id: '7a30d582-1e94-4c67-b8f2-5d06a9e13b74',
      permission: { namespace: 'merge', action: 'person_view' },
    },
    children: [
      {
        name: 'Mesclar Cadastros',
        url: '/cadastro/merge/pessoas',
        icon: 'fas fa-people-arrows',
        attributes: {
          id: '81f7c052-3d6b-49ae-8f14-6b2c7a90e5d3',
          permission: { namespace: 'merge', action: 'person_view' },
        },
      },
      {
        name: 'Histórico de Mesclagens',
        url: '/cadastro/merge/historico',
        icon: 'fas fa-history',
        attributes: {
          id: 'd35b6a18-9c72-4e0f-a641-8073f2e5b9c1',
          permission: { namespace: 'merge', action: 'person_view' },
        },
      },
    ],
  },
  // ---- Configurações ----
  {
    name: 'Configurações',
    icon: 'fas fa-cog',
    url: '.',
    children: [
      {
        name: 'Situações',
        url: '/cadastro/config/situacao',
        icon: 'fas fa-flag',
        attributes: {
          id: 'b10a393c-b914-47c9-80c7-ee4f0b9c606b',
          permission: { namespace: 'people', action: 'person_situation_list' },
        },
      },
      {
        name: 'Marcadores',
        url: '/cadastro/config/marcador',
        icon: 'fas fa-tags',
        attributes: {
          id: '8e8d4e41-aeff-49d0-8441-333c7a07c0d5',
          permission: { namespace: 'people', action: 'person_tag_list' },
        },
      },
      {
        name: 'Campos Personalizados',
        url: '/cadastro/config/campos',
        icon: 'fas fa-clipboard-list',
        attributes: {
          id: '0dcbadd2-1bf7-41e8-9107-1a25542e2dc5',
          permission: { namespace: 'people', action: 'custom_field_list' },
        },
      },
    ]
  },
];
